import { getAccOrigin } from '@adsk/acs-sc-web-platform-api';

export default function getNotificationSettingsUrl(projectId: string) {
  return `${getAccOrigin()}/settings/projects/${projectId}/notifications?previousPage=${encodeURIComponent(
    window.location.href,
  )}`;
}
